import { setChatListSyncFailed, setChatListSyncPending, setChatListSyncSucceed } from './actions';
import { currentOpenChatIDSelector, isShowSubAgentChatListSelector } from '../../selectors';
import { syncChatsV2, TSyncChatsV2ParamsRequest } from '../../services/chatsList/syncChatsV2';
import { EHostType } from '../../types/hostType';
import { TThunkAction } from '../../types/redux/thunk';
import { getQueryParamsFetchChatsList } from '../../utils/getQueryParamsFetchChatsList';
import { closeChat } from '../chatWindow';

/**
 * Получить список чатов для синхронизации
 */
export const synchronizeChatsV2 = (): TThunkAction<Promise<void>> => async (dispatch, getState, context) => {
  const state = getState();

  const {
    hostType,
    chatList,
    masterFilters: { selectedSubAgentId },
  } = state;

  // TODO убрать после фикса на беке
  if (hostType === EHostType.Frame) {
    return;
  }

  const { currentRoute, chats } = chatList;
  const chatIds = chats.map(chat => chat.chatId);
  const timestampFirst = state.chatList.currentPage ? chats[0].updatedMs : undefined;
  const timestampLast = chats[chats.length - 1].updatedMs;
  const { status, filterBy } = getQueryParamsFetchChatsList(currentRoute);

  const subAgentRealtyUserId = isShowSubAgentChatListSelector(state) ? selectedSubAgentId : undefined;

  dispatch(setChatListSyncPending());

  // Чаты выбираются по датам minDatetimeForSorting и maxDatetimeForSorting, и в запросе так же обязательно передаем статус.
  // Может быть так чат на клиенте в активном, но на самом деле на бекенде он уже в архиве.
  // Клиент передает 2 даты и статус активные для синхронизации табов на бек.
  // Бекенд вернет все чаты активные чаты в эти даты. А вот про активный/архивный чат на клиенте он ничего не знает.
  // В итоге чат останется висеть в активных на клиенте.
  // Чтобы это избежать передается список id чатов. По нем мы отслеживает не было ли перемещения между категориями чата.
  // minDatetimeForSorting - да последнего чата в текущей странице
  // minDatetimeForSorting - не передаем если это первая страница, если страница не первая - то это будет сохраненная дата последнего

  const parameters: TSyncChatsV2ParamsRequest = {
    subAgentRealtyUserId,
    status,
    filterBy,
    chatIds,
    minDatetimeForSorting: timestampLast ? new Date(timestampLast).toISOString() : new Date().toISOString(),
    maxDatetimeForSorting: timestampFirst ? new Date(timestampFirst).toISOString() : undefined,
  };

  const response = await syncChatsV2(context, {
    parameters,
  });

  if (response.chats !== null) {
    dispatch(setChatListSyncSucceed({ chats: response.chats, isV2Version: true }));
  } else {
    dispatch(setChatListSyncFailed());
  }

  if (response.movedChatIds && response.movedChatIds.length > 0) {
    const updatedState = getState();

    const chatId = currentOpenChatIDSelector(updatedState);

    // Если открыт чат, который был перемещен, сбрасываем открытый чат
    if (chatId && response.movedChatIds.includes(chatId)) {
      dispatch(closeChat());
    }
  }
};
